// Module
var code = `<div class="error-modal">
    <div class="error-title">{{ data.title || 'Account Not Found' }}</div>
    <div class="error-message">
        {{ data.message }}

        <ng-container *ngIf="data.contactInfo">
            Please contact
            <a [href]="'mailto:' + data.contactInfo.email"
               class="contact-link">
                {{ data.contactInfo.companyName }}
            </a>
            should you continue to receive this error at
            {{ data.contactInfo.phone }}<span *ngIf="data.contactInfo.phoneOption">, {{ data.contactInfo.phoneOption }}</span>.
        </ng-container>
    </div>
    <div class="dialog-actions">
        <button class="ok-button" (click)="closeDialog()">OK</button>
    </div>
</div>`;
// Exports
module.exports = code;